import { Bleed, Box } from 'braid-design-system';
import React from 'react';

import {
  HomeLogoButton,
  BuyABusinessButton,
  SellABusinessButton,
  FranchiseButton,
  BlogButton,
  FindBrokersButton,
} from './Desktop/NavButtons';
import { ProfileActions } from './Desktop/ProfileActions';
import {
  desktopSmallHeaderContainerId,
  dropdownStateDataAttr,
  navHeaderBannerIds,
} from './utils/generalUtils';
import type { RenderVariant } from './utils/typeUtils';

import * as styles from './DesktopSmallHeader.css';

interface DesktopSmallHeaderProps {
  variant: RenderVariant;
  baseUrl: string;
  advertiserCentreUrl: string;
}

export const DesktopSmallHeader = ({
  variant,
  baseUrl,
  advertiserCentreUrl,
}: DesktopSmallHeaderProps) => (
  <Box
    component="header"
    id={desktopSmallHeaderContainerId}
    data={{
      testid: navHeaderBannerIds.desktopSmall,
      [dropdownStateDataAttr]: 'closed',
    }}
  >
    <nav aria-label="Main menu" className={styles.navHeaderContainer}>
      <Box className={styles.navHeaderUpperContainer}>
        <Box flexGrow={1}>
          <HomeLogoButton baseUrl={baseUrl} />
        </Box>

        <Box className={styles.navRightSideContainer}>
          <ProfileActions
            variant={variant}
            baseUrl={baseUrl}
            advertiserCentreUrl={advertiserCentreUrl}
          />
        </Box>
      </Box>

      <Box paddingX="large">
        {/* Bleed offsets the button padding for alignment */}
        <Bleed horizontal="small">
          <BuyABusinessButton baseUrl={baseUrl} />
          <SellABusinessButton baseUrl={baseUrl} />
          <FranchiseButton baseUrl={baseUrl} />
          <FindBrokersButton baseUrl={baseUrl} />
          <BlogButton baseUrl={baseUrl} />
        </Bleed>
      </Box>
    </nav>
  </Box>
);
